/* eslint-disable no-undef */
import createIdbStorage from '@piotr-cz/redux-persist-idb-storage'
import { combineReducers } from 'redux'
import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import accessControl from './accessControl/reducers'
import auth from './auth/reducers'
import azure from './azure/reducers'
import contract from './contract/reducers'
import dateConfig from './dateConfig/reducers'
import frames from './frames/reducers'
import locale from './locale/reducers'
import siderMenu from './siderMenu/reducers'
import tags from './tags/reducers'
import theme from './theme/reducers'
import units from './units/reducers'
import unitSelected from './unitSelected/reducers'
import user from './user/reducers'
import whiteLabel from './whiteLabel/reducers'

const localePersistConfig = {
  key: 'intelup@locale',
  storage,
}

const themePersistConfig = {
  key: 'intelup@theme',
  storage: globalThis.indexedDB
    ? createIdbStorage({ name: 'intelup', storeName: 'intelup' })
    : storage,
  serialize: false,
  deserialize: false,
}

const tagsPersistConfig = {
  key: 'intelup@tags',
  storage: globalThis.indexedDB
    ? createIdbStorage({ name: 'intelup', storeName: 'intelup' })
    : storage,
  serialize: false,
  deserialize: false,
}

const framesPersistConfig = {
  key: 'intelup@frames',
  storage: globalThis.indexedDB
    ? createIdbStorage({ name: 'intelup', storeName: 'intelup' })
    : storage,
  serialize: false,
  deserialize: false,
}

const unitsPersistConfig = {
  key: 'intelup@units',
  storage,
}

const dateConfigPersistConfig = {
  key: 'intelup@dateConfig',
  storage: globalThis.indexedDB
    ? createIdbStorage({ name: 'intelup', storeName: 'intelup' })
    : storage,
  serialize: false,
  deserialize: false,
}

const whiteLabelPersistConfig = {
  key: 'intelup@whiteLabel',
  storage: globalThis.indexedDB
    ? createIdbStorage({ name: 'intelup', storeName: 'intelup' })
    : storage,
  serialize: false,
  deserialize: false,
}

export default combineReducers({
  locale: persistReducer(localePersistConfig, locale),
  auth,
  user,
  units: persistReducer(unitsPersistConfig, units),
  unitSelected,
  accessControl,
  siderMenu,
  contract,
  whiteLabel: persistReducer(whiteLabelPersistConfig, whiteLabel),
  theme: persistReducer(themePersistConfig, theme),
  tags: persistReducer(tagsPersistConfig, tags),
  frames: persistReducer(framesPersistConfig, frames),
  dateConfig: persistReducer(dateConfigPersistConfig, dateConfig),
  azure,
})
